"use strict";

exports.__esModule = true;
exports.POST_EXCERPT_MAX_LENGTH = void 0;
var POST_EXCERPT_MAX_LENGTH = 480;
exports.POST_EXCERPT_MAX_LENGTH = POST_EXCERPT_MAX_LENGTH;